import React from "react";
import Dashboard from "../pages/dashboard/index";
import Customer from "../pages/customer";
import Invoicedetails from "../pages/invoicedetails/Invoicedetails";
import CustomerDetails from "../pages/customer-details/index";
import SalesLead from "../pages/salelead";
import Home from "../pages/home";
import Reset from "../pages/resetpassword/index";
import Account from "../pages/account/index";
import AccountGuarntee from "../pages/AccountGuarntee";
import AddSaleLead from "../pages/salelead/AddSaleLead";
import EditSaleLead from "../pages/salelead/EditSaleLead";
import RefferalPartner from "../pages/refferal-partner";
import CreatePartner from "../pages/refferal-partner/CreatePartner";
import EditRefferalPartner from "../pages/refferal-partner/EditReferralPartner";
import Role from "../pages/accessmanagment/role-management";
import UserManagement from "../pages/accessmanagment/user-management";
import DeleteUser from "../pages/accessmanagment/user-management/DeleteUser";
import CreateUser from "../pages/accessmanagment/user-management/CreateUser";
import ViewUser from "../pages/accessmanagment/user-management/ViewUser";
import CreateRole from "../pages/accessmanagment/role-management/CreateRole";
import EditUserManage from "../pages/accessmanagment/user-management/EditUserManage";
import EditRoleManage from "../pages/accessmanagment/role-management/EditRoleManage";
import PricingPlan from "../pages/pricing-plan";
import EditPricingPlan from "../pages/pricing-plan/EditPricingPlan";
import CreatePricingPlan from "../pages/pricing-plan/CreatePricingPlan";
import EditPricingPlanGroup from "../pages/pricing-plan/EditPricingPlanGroup";
import PromoCodePage from "../pages/promo-code";
import CreatePromoCode from "../pages/promo-code/CreatePromoCode";
import EditPromoCode from "../pages/promo-code/EditPromoCode";
import EmailTemplate from "../pages/emailtemplate";
import SmsTemplate from "../pages/smstemplate";
import UpdateFundedAmount from "../pages/updatefundedamount";
import BannerNotification from "../pages/bannernotification";
import EditBannerNotification from "../pages/bannernotification/EditBannerNotification";
import CreateBannerNotification from "../pages/bannernotification/CreateBannerNotification";
import CreatePlatformPartnerApi from "../pages/platform-partner-api-management/CreatePlatformPartnerApi";
import EditPlatformPartnerApi from "../pages/platform-partner-api-management/EditPlatformPartnerApi";
import ChangeUserPassword from "../pages/accessmanagment/user-management/ChangeUserPassword";
import DeactivateUser from "../pages/accessmanagment/user-management/DeactivateUser";
import CustomerRepoDetails from "../pages/reports/customer-details";
import OverdueReport from "../pages/reports/overdue";
import MonthlyLending from "../pages/reports/monthly-lending";
import CreateSmsTemplate from "../pages/smstemplate/CreateSmsTemplate";
import ResetPassword from "../pages/ResetPassword";
import EditSmsTemplate from "../pages/smstemplate/EditSmsTemplate";
import IndustrySector from "../pages/reports/industry-sectors";
import CreatePricingPlanGroup from "../pages/pricing-plan/CreatePricingPlanGroup";
import EditMailTemplate from "../pages/emailtemplate/EditMailTemplate";
import AllLogs from "../pages/log-viewers/alllogs";
import CreatePricingPlanSection from "../pages/pricing-plan/CreatePricingPlanSection";
import Repaymentslogs from "../pages/log-viewers/repaymentlogs";
import AiData from "../pages/reports/ai-data";
import ConferenceSignUp from "../pages/ConferenceSignUp";
import LTVReport from "../pages/reports/ltv-report";
import MonthlyKpiReport from "../pages/reports/kpi-report";
import MlinvoiceManagement from "../pages/ml-invoice-management/MlinvoiceManagement";
import CurrentPaymentsReport from "../pages/reports/payments";
import ReferenceSignUPromocode from "../pages/reference-signUp-promocode/ReferenceSignUPromocode";
import DuplicatePartner from "../pages/refferal-partner/DuplicatePartner";
import MyobCallBack from "../components/callback/MyobCallBack";
import ReckonCallBack from "../components/callback/ReckonCallBack";
import XeroCallBack from "../components/callback/XeroCallBack";
import AccountingSoftware from "../pages/accountingsoftware";
import EditAccountingSoftware from "../pages/accountingsoftware/EditAccountingSoftware";
import CreateAccountingSoftware from "../pages/accountingsoftware/CreateAccountingSoftware";
import QuickBooksCallBack from "../components/callback/QuickbooksCallBack";
import DemoAccountInvoiceConnect from "../pages/DemoAccountInvoiceConnect";
import DemoAccountHome from "../pages/DemoAccountHome";
import MultiStepForm from "../components/MultiStepForm/MultiStepForm";
import MobileDeviceCallBack from "../components/all-account-steps/MobileDeviceCallBack";
import VerifyConfirmationEmail from "../pages/VerifyConfirmationEmail";
import GocardLessCallBack from "../components/callback/GocardLessCallBack";
import PromoCodeRedirect from "../pages/promo-code/PromoCodeRedirect";
import LoansLessHundred from "../pages/reports/loanslesshundred";
import ChecklistQuestions from "../pages/checklist-question";
import TcGuarnteeClient from "../pages/agreement-email-pages/agreement";
import AddOtherOwners from "../pages/agreement-email-pages/others-owners";
import GuaranteeNoID from "../pages/agreement-email-pages/guarantee-no-Id";
import BiometricIdVerification from "../pages/agreement-email-pages/biometric-id-verification";
import Faqs from "../pages/faqs";
import DateForPayment from "../pages/directdebit-mail-template/DateForPayment";
import PaymentNow from "../pages/directdebit-mail-template/PaymentNow";
import MonthlySalesCommission from "../pages/reports/monthly-sales-commision";
import ErrorBoundary from "../components/error-boundary";
import ListViewFallback from "../components/error-boundary/fallback/ListViewFallback";
import SingleAccountingSoftware from "../pages/invoiceconnect/SingleAccountingSoftware";
import TCGuarantee from "../pages/agreement-email-pages/tc-guarantee";
import Onboarding from "../pages/onboarding";
import ManualPaymentSync from "../pages/payment-updates/ManualPaymentSync";
import Permission from "../pages/accessmanagment/permission";
import PermissionForm from "../pages/accessmanagment/permission/PermissionForm";
import Forbidden from "../pages/Forbidden";
import TotalOwingNotZeroReport from "../pages/reports/total-owing-zero";
import PartnerDashboard from "../pages/partner-portal/PartnerDashboard";
import PartnerCommission from "../pages/partner-portal/PartnerCommission";
import Statements from "../pages/statements";
import LoginWithRecaptcha from "../pages/login/LoginWithRecaptcha";
import SignupWithRecaptcha from "../pages/signup/SignupWithRecaptcha";
import ReffPartnerSignupWithRecaptcha from "../pages/refferal-partner/refferal-partner-page/ReffPartnerSignupWithRecaptcha";

export const publicRoutes = [
  { path: "/login", element: <LoginWithRecaptcha /> },
  { path: "/password/reset-link", element: <ResetPassword /> },
  { path: "/password/reset", element: <Reset /> },
  { path: "/sign-up/:referralCode?", element: <SignupWithRecaptcha /> },
  {
    path: "/verify-confirmation-email/:token",
    element: <VerifyConfirmationEmail />
  },
  { path: "/submit-agreement-document/:token?", element: <AccountGuarntee /> },
  { path: "/partners/:referralCode", element: <ReferenceSignUPromocode /> },
  {
    path: "/referral-sign-up/:userId/:promoCodeId/:historyId",
    element: <PromoCodeRedirect />
  },
  {
    path: "/sign-up/:promoCode/:referralPromoUsageHistoryId",
    element: <SignupWithRecaptcha />
  },
  {
    path: "/answer-checklist-questions/:token?",
    element: <ChecklistQuestions />
  },
  { path: "/demo-account/invoice", element: <DemoAccountHome /> },
  { path: "/demo-account/invoices", element: <DemoAccountInvoiceConnect /> },
  { path: "/:referralCode", element: <ReffPartnerSignupWithRecaptcha /> },
  { path: "/refer/:referralCode", element: <ReffPartnerSignupWithRecaptcha /> },
  { path: "/tc-guarantee/:token?", element: <TcGuarnteeClient /> },
  { path: "/add-other-owner/:token?", element: <AddOtherOwners /> },
  { path: "/tc-guarantee-client/:token?", element: <GuaranteeNoID /> },
  { path: "/tc_guarantee_client/:token?", element: <TCGuarantee /> },
  { path: "/tc-id-verification/:token?", element: <BiometricIdVerification /> },
  { path: "/date-for-payment/:uuid?", element: <DateForPayment /> },
  { path: "/pay-now/:uuid?", element: <PaymentNow /> },
  { path: "/upload-documents/:token?", element: <Account /> }
];

export const routesWithSidebar = [
  {
    path: "/admin/dashboard",
    element: <Dashboard />,
    permissions: ["BACKEND:ACCESS_VIEW", "LOAN:QUOTE:DASHBOARD"]
  },
  {
    path: "/admin/customers",
    element: <Customer />,
    permissions: ["LOAN:GET_CUSTOMER_DETAILS"]
  },
  {
    path: "/dashboard/invoice-details/:id",
    element: <Invoicedetails />,
    permissions: ["LOAN:QUOTE:VIEW"]
  },
  {
    path: "/admin/access/client-details/:id",
    element: (
      <ErrorBoundary fallback={<ListViewFallback />}>
        <CustomerDetails />
      </ErrorBoundary>
    ),
    permissions: ["USER_MGMT:USER:CUSTOMER_DETAILS"]
  },
  {
    path: "/admin/sales-leads",
    element: <SalesLead />,
    permissions: ["SALES_LEAD_PERSON:GET_ALL"]
  },
  {
    path: "/admin/sales-leads/create/",
    element: <AddSaleLead />,
    permissions: ["SALES_LEAD_PERSON:CREATE"]
  },
  {
    path: "/admin/sales-leads/edit/:rowId",
    element: <EditSaleLead />,
    permissions: ["SALES_LEAD_PERSON:UPDATE"]
  },
  {
    path: "/admin/referral-partners",
    element: <RefferalPartner />,
    permissions: ["REFERRAL_PARTNER:GET_ALL"]
  },
  {
    path: "/admin/referral-partners/create",
    element: <CreatePartner />,
    permissions: ["REFERRAL_PARTNER:CREATE"]
  },
  {
    path: "/admin/referral-partners/edit/:id",
    element: <EditRefferalPartner />,
    permissions: ["REFERRAL_PARTNER:UPDATE"]
  },
  {
    path: "/admin/referral-partners/duplicate/:id",
    element: <DuplicatePartner />,
    permissions: ["REFERRAL_PARTNER:CREATE"]
  },
  {
    path: "/admin/access/permission/create",
    element: <PermissionForm />,
    permissions: []
  },
  {
    path: "/admin/access/permission/edit/:id",
    element: <PermissionForm />,
    permissions: []
  },
  {
    path: "/admin/access/permission",
    element: <Permission />,
    permissions: []
  },
  {
    path: "/admin/access/role",
    element: <Role />,
    permissions: ["ROLE:GET_ALL"]
  },
  {
    path: "/admin/access/user",
    element: <UserManagement />,
    permissions: ["USER:GET_ALL"]
  },
  {
    path: "/admin/access/user/deleted",
    element: <DeleteUser />,
    permissions: ["USER:DELETE"]
  },
  {
    path: "/admin/access/user/create",
    element: <CreateUser />,
    permissions: ["USER:CREATE"]
  },
  {
    path: "/admin/access/user/view-user/:userId",
    element: <ViewUser />,
    permissions: ["USER:GET_ALL"]
  },
  {
    path: "/admin/access/user/edit/:id",
    element: <EditUserManage />,
    permissions: ["USER:UPDATE"]
  },
  {
    path: "/admin/access/user/change-password/:passId",
    element: <ChangeUserPassword />,
    permissions: ["ADMIN:CHANGE_PASSWORD"]
  },
  {
    path: "/admin/access/role/create",
    element: <CreateRole />,
    permissions: ["ROLE:CREATE"]
  },
  {
    path: "/admin/access/role/edit/:id",
    element: <EditRoleManage />,
    permissions: ["ROLE:UPDATE"]
  },
  {
    path: "/admin/pricing-plans",
    element: <PricingPlan />,
    permissions: ["LOAN:PRICING_PLAN:VIEW_ALL"]
  },
  {
    path: "/admin/pricing-plans/edit-plan/:rowId",
    element: <EditPricingPlan />,
    permissions: ["LOAN:PRICING_PLAN:UPDATE"]
  },
  {
    path: "/admin/pricing-plans/create-plan",
    element: <CreatePricingPlan />,
    permissions: ["LOAN:PRICING_PLAN:CREATE"]
  },
  {
    path: "/admin/pricing-plans/create-riskbased-plan/:id",
    element: <CreatePricingPlanSection />,
    permissions: ["LOAN:PRICING_PLAN:CREATE"]
  },
  {
    path: "/admin/pricing-plans/edit-plan-group/:id",
    element: <EditPricingPlanGroup />,
    permissions: ["LOAN:PRICING_PLAN:UPDATE"]
  },
  {
    path: "/admin/pricing-plans/create-plan-group",
    element: <CreatePricingPlanGroup />,
    permissions: ["LOAN:PRICING_PLAN:CREATE"]
  },
  {
    path: "/admin/promo-codes",
    element: <PromoCodePage />,
    permissions: ["LOAN:PROMO_CODE:SEARCH"]
  },
  {
    path: "/admin/promo-codes/create",
    element: <CreatePromoCode />,
    permissions: ["LOAN:PROMO_CODE:CREATE"]
  },
  {
    path: "/admin/promo-codes/edit/:rowId",
    element: <EditPromoCode />,
    permissions: ["LOAN:PROMO_CODE:UPDATE"]
  },
  {
    path: "/admin/email-templates",
    element: <EmailTemplate />,
    permissions: ["EMAIL_TEMPLATE:GET_ALL"]
  },
  {
    path: "/admin/sms-templates",
    element: <SmsTemplate />,
    permissions: ["SMS_TEMPLATE:GET_ALL"]
  },
  {
    path: "/admin/funded-amount-updates",
    element: <UpdateFundedAmount />,
    permissions: ["LOAN:QUOTE:UPDATE_FUNDED_AMOUNT"]
  },
  {
    path: "/admin/banner-notifications",
    element: <BannerNotification />,
    permissions: ["SCHEDULED_NOTIFICATION:GET_ALL"]
  },
  {
    path: "/platform-partner/create",
    element: <CreatePlatformPartnerApi />,
    permissions: []
  },
  {
    path: "/platform-partner/edit/:rowId",
    element: <EditPlatformPartnerApi />,
    permissions: []
  },
  {
    path: "/admin/banner-notifications/create",
    element: <CreateBannerNotification />,
    permissions: ["SCHEDULED_NOTIFICATION:CREATE"]
  },
  {
    path: "/admin/banner-notifications/edit/:rowId",
    element: <EditBannerNotification />,
    permissions: ["SCHEDULED_NOTIFICATION:UPDATE"]
  },
  {
    path: "/admin/access/user/deactivated",
    element: <DeactivateUser />,
    permissions: ["USER:UPDATE"]
  },
  {
    path: "/admin/reports/customer-details",
    element: <CustomerRepoDetails />,
    permissions: ["REPORT:CUSTOMER_DETAILS:VIEW"]
  },
  {
    path: "/admin/reports/overdue",
    element: <OverdueReport />,
    permissions: ["REPORT:OVERDUE:VIEW"]
  },
  {
    path: "/admin/reports/sales-commission",
    element: <MonthlySalesCommission />,
    permissions: ["REPORT:SALES_COMMISSION_REPORT"]
  },
  {
    path: "/admin/reports/monthly-lending",
    element: <MonthlyLending />,
    permissions: ["REPORT:LENDING:MONTHLY"]
  },
  {
    path: "/admin/sms-template/create",
    element: <CreateSmsTemplate />,
    permissions: ["SMS_TEMPLATE:CREATE"]
  },
  {
    path: "/admin/sms-template/edit/:id",
    element: <EditSmsTemplate />,
    permissions: ["SMS_TEMPLATE:UPDATE"]
  },
  {
    path: "/admin/edit-email-template/:id",
    element: <EditMailTemplate />,
    permissions: ["EMAIL_TEMPLATE:UPDATE"]
  },
  {
    path: "/admin/reports/industry-sectors",
    element: <IndustrySector />,
    permissions: ["REPORT:INDUSTRY_SECTOR_REPORT_TABLE"]
  },
  {
    path: "/admin/reports/kpi",
    element: <MonthlyKpiReport />,
    permissions: ["REPORT:KPI_GENERATE_TABLE"]
  },
  {
    path: "/admin/logs/all",
    element: <AllLogs />,
    permissions: ["USER_ACTIVITY:GET_ALL"]
  },
  {
    path: "/admin/logs/repayment",
    element: <Repaymentslogs />,
    permissions: ["LOAN:REPAYMENT_CHANGE_LOGS:VIEW_ALL"]
  },
  {
    path: "/admin/reports/ai-data",
    element: <AiData />,
    permissions: ["REPORT:AI_INSIGHTS"]
  },
  {
    path: "/admin/reports/ltv",
    element: <LTVReport />,
    permissions: ["SALES_LEAD_PERSON:GET_LEADS"]
  },
  { path: "/admin/ml", element: <MlinvoiceManagement />, permissions: [] },
  {
    path: "/admin/reports/payments",
    element: <CurrentPaymentsReport />,
    permissions: ["REPORT:PAYMENTS:VIEW"]
  },
  {
    path: "/admin/reports/total-owing-not-zero",
    element: <TotalOwingNotZeroReport />,
    permissions: ["REPORT:TOTAL_OWING:VIEW"]
  },
  {
    path: "/admin/payment-updates",
    element: <ManualPaymentSync />,
    permissions: ["PAYMENT_SYNC:CURRENT_LOGS"]
  },
  {
    path: "/admin/accounting-softwares",
    element: <AccountingSoftware />,
    permissions: ["ACCOUNTING_SOFTWARE:LIST"]
  },
  {
    path: "/admin/accounting-softwares/edit/:id",
    element: <EditAccountingSoftware />,
    permissions: ["ACCOUNTING_SOFTWARE:UPDATE"]
  },
  {
    path: "/admin/accounting-softwares/create",
    element: <CreateAccountingSoftware />,
    permissions: ["ACCOUNTING_SOFTWARE:CREATE"]
  },
  {
    path: "/admin/reports/loans-below-100",
    element: <LoansLessHundred />,
    permissions: ["REPORT:QUOTE:VIEW_LESS_THAN_HUNDRED"]
  },
  { path: "/admin/forbidden", element: <Forbidden />, permissions: [] }
];

export const partnerRoutes = [
  { path: "/partner/dashboard", element: <PartnerDashboard /> },
  { path: "/partner/clients", element: <PartnerDashboard /> },
  { path: "/partner/commission", element: <PartnerCommission /> }
];
export const routes = [
  { path: "/", element: <Home /> },
  { path: "/invoice", element: <Home /> },
  { path: "/accounting-software", element: <SingleAccountingSoftware /> },
  { path: "/account", element: <Account /> },
  { path: "/statements", element: <Statements /> },
  { path: "/faqs", element: <Faqs /> },
  { path: "/complete-account-setup", element: <MultiStepForm /> },
  { path: "/onboarding", element: <Onboarding /> },
  {
    path: "/aplyid/verify-your-identity/:id",
    element: <MobileDeviceCallBack />
  },
  { path: "/conference-sign-up", element: <ConferenceSignUp /> },
  { path: "/reckon-callback", element: <ReckonCallBack /> },
  { path: "/myob/callback", element: <MyobCallBack /> },
  { path: "/gocardless-callback", element: <GocardLessCallBack /> },
  { path: "/xero-callback", element: <XeroCallBack /> },
  { path: "/quickbooks-callback", element: <QuickBooksCallBack /> }
];
